var _excluded = ["options", "children", "value", "style", "defaultValue", "onChange", "className"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { cx } from '@emotion/css';
import Radio from "./Radio";
import { styleRadioGroup, prefix } from "./index.style";
export var GroupContext = /*#__PURE__*/React.createContext(null);

var InternalRadioGroup = function InternalRadioGroup(_ref, ref) {
  var _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      children = _ref.children,
      value = _ref.value,
      style = _ref.style,
      defaultValue = _ref.defaultValue,
      onChange = _ref.onChange,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _React$useState = React.useState(value || defaultValue || undefined),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      mergeValue = _React$useState2[0],
      setMergeValue = _React$useState2[1];

  var getOptions = React.useCallback(function () {
    return options.map(function (option) {
      if (typeof option === 'string' || typeof option === 'number') {
        return {
          label: option,
          value: option
        };
      }

      return option;
    });
  }, [options]);

  if (options && options.length > 0) {
    children = getOptions().map(function (option) {
      return /*#__PURE__*/React.createElement(Radio, {
        key: option.value.toString(),
        disabled: 'disabled' in option ? option.disabled : restProps.disabled,
        value: option.value,
        checked: value === option.value,
        className: prefix('group-item')()
      }, option.label);
    });
  }

  var changeRadio = function changeRadio(e) {
    var checkedValue = e.target.value;

    if (value === undefined) {
      setMergeValue(checkedValue);
    } // TODO: comfirm if this branch is necessary
    // if (checkedValue !== mergeValue) {


    onChange === null || onChange === void 0 ? void 0 : onChange(checkedValue, e); // }
  };

  var content = {
    name: restProps.name,
    value: mergeValue,
    changeRadio: changeRadio,
    disabled: restProps.disabled
  };
  React.useEffect(function () {
    if (value !== undefined) {
      setMergeValue(value);
    }
  }, [value]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    style: style,
    className: cx(styleRadioGroup, className)
  }, /*#__PURE__*/React.createElement(GroupContext.Provider, {
    value: content
  }, children));
};

var RadioGroup = /*#__PURE__*/React.forwardRef(InternalRadioGroup);
RadioGroup.displayName = 'RadioGroup';
RadioGroup.defaultProps = {
  disabled: false
};
export default /*#__PURE__*/React.memo(RadioGroup);